
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  function getPreviewThemeId() {
    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) {
      return previewId;
    }

    var host = window.location.hostname;
    if (host === '127.0.0.1' || host === 'localhost') {
      return window.flitsObjects &&
        window.flitsObjects.storeData &&
        window.flitsObjects.storeData.theme &&
        window.flitsObjects.storeData.theme.id;
    }

    return null;
  }

  function withPreviewThemeId(url) {
    if (typeof url !== 'string' || url.indexOf('/account') !== 0 || url.indexOf('view=flits_') === -1) {
      return url;
    }

    var previewId = getPreviewThemeId();
    if (!previewId) {
      return url;
    }

    try {
      var nextUrl = new URL(url, window.location.origin);
      if (!nextUrl.searchParams.has('preview_theme_id')) {
        nextUrl.searchParams.set('preview_theme_id', previewId);
      }
      return nextUrl.pathname + '?' + nextUrl.searchParams.toString();
    } catch (error) {
      return url;
    }
  }

  function extractModuleHtml(resp, moduleSelector) {
    if (!resp) {
      return '';
    }

    var parsed = Flits(resp);
    var html = parsed.filter(moduleSelector).find('.flits-content').html();

    if (!html) {
      html = parsed.find(moduleSelector + ' .flits-content').html();
    }

    if (!html && moduleSelector === '.flits-content') {
      html = parsed.filter('.flits-content').html();
    }

    if (!html && moduleSelector === '.flits-content') {
      html = parsed.find('.flits-content').first().html();
    }

    return html || '';
  }

  function injectIfMissing(tabSelector, moduleSelector, afterInject) {
    var tab = Flits(tabSelector);
    if (!tab.length || tab.find('.flits-tab-box-body, .flits-content').length) {
      return;
    }

    var url = withPreviewThemeId('/account?view=flits_profile_template');
    if (tabSelector === '#flits_tab_address') {
      url = withPreviewThemeId('/account?view=flits_address_template');
    } else if (tabSelector === '#flits_tab_order') {
      url = withPreviewThemeId('/account?view=flits_order_template');
    } else if (tabSelector === '#flits_tab_changePassword') {
      url = withPreviewThemeId('/account?view=flits_profile_template');
      moduleSelector = '.flits-change-password-module';
    }

    Flits.get(url, function(resp) {
      var html = extractModuleHtml(resp, moduleSelector);
      if (!html) {
        return;
      }

      tab.find('.flits-module-loader, .flits-order-module-loader').remove();
      tab.append(html);

      if (afterInject) {
        afterInject();
      }
    }, 'html');
  }

  var originalGet = Flits.get;
  Flits.get = function(url, data, callback, type) {
    var patchedUrl = withPreviewThemeId(url);

    if (typeof data === 'function') {
      type = type || callback;
      callback = data;
      data = undefined;
    }

    if (typeof callback === 'function') {
      var userCallback = callback;
      callback = function(resp) {
        userCallback(resp);

        if (patchedUrl.indexOf('view=flits_profile_template') !== -1) {
          setTimeout(function() {
            var profileTab = Flits('#flits_tab_profile');
            if (!profileTab.find('.flits-tab-box-body').length) {
              var html = extractModuleHtml(resp, '.flits-profile-module');
              if (html) {
                profileTab.find('.flits-module-loader').remove();
                profileTab.append(html);
                Flits.myProfile && Flits.myProfile();
                Flits.birthdayCountDown && Flits.birthdayCountDown();
              }
            }
          }, 0);
        }
      };
    }

    return originalGet.call(this, patchedUrl, data, callback, type);
  };

  Flits(document).on('Flits:AccountPage:Visible', function() {
    setTimeout(function() {
      injectIfMissing('#flits_tab_profile', '.flits-profile-module', function() {
        Flits.myProfile && Flits.myProfile();
        Flits.birthdayCountDown && Flits.birthdayCountDown();
      });
      injectIfMissing('#flits_tab_address', '.flits-content', function() {
        Flits.deliveryAddress && Flits.deliveryAddress();
      });
      injectIfMissing('#flits_tab_order', '.flits-content', function() {
        Flits.order && Flits.order();
      });
      injectIfMissing('#flits_tab_changePassword', '.flits-change-password-module', function() {
        Flits.updatePassword && Flits.updatePassword();
      });
    }, 1000);
  });
}(Flits));
